module.exports = __webpack_public_path__ + "img/no_delay_icon.b33434d7.svg";